import { Controller } from "@hotwired/stimulus";
import { getApps, initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";

export default class extends Controller {
  connect() {
    const firebaseConfig = {
      apiKey: "AIzaSyAoGLGYST59btTzE-I_uU_X7dsyPOKlyhs",
      authDomain: "saludtech-48e78.firebaseapp.com",
      databaseURL: "https://saludtech-48e78.firebaseio.com/",
      projectId: "saludtech-48e78",
      storageBucket: "saludtech-48e78.appspot.com",
      messagingSenderId: "123295551612",
      appId: "1:123295551612:web:73b2547001a0a1455e39f9",
      measurementId: "G-360LGEV1EY",
    };

    if (getApps().length === 0) {
      initializeApp(firebaseConfig);
    }
  }

  handleGetToken(idToken, prevWindow) {
    const basePath = this.data.get("path");
    const formType = this.data.get("form-type");
    // Carry the sign-up page's marketing opt-in (users/_marketing_consent_field) through Google sign-up.
    const consent = document.getElementById("accept_marketing_consent")?.checked ? "&accept_marketing_consent=1" : "";
    if (formType) {
      prevWindow.location.href = `${basePath}?t=${idToken}&form=${formType}${consent}`;
    } else {
      prevWindow.location.href = `${basePath}?t=${idToken}${consent}`;
    }
  }

  async onSignIn() {
    const auth = getAuth();
    const provider = new GoogleAuthProvider();

    await signInWithPopup(auth, provider);

    auth.currentUser
      .getIdToken(true)
      .then((idToken) => this.handleGetToken(idToken, window))
      .catch((error) => console.log(error));
  }
}
